<!-- 
  Generated template for the SurveyPage page.

  See http://ionicframework.com/docs/components/#navigation for more info on
  Ionic pages and navigation.
-->

<app-generic-header [goBack] = "back.bind(this)" [title]="'survey' | translate" variant="back">
</app-generic-header>


<ion-content class="ion-padding" (swipe)="swipeEvent($event)" id="contentDiv">
  <div class="frameDiv">
    <div class="mainDiv">


      <div *ngFor="let form of forms; let i = index">
        

        <div *ngIf="step===(i+1)">

          <p>{{('Q' + (i+1)) | translate}}</p>

          <ion-list *ngIf="form.type === 'checkbox'">
            <ion-item *ngFor="let entry of form.answers">
              <ion-checkbox [(ngModel)]="entry.value">{{ entry.label | translate }}</ion-checkbox>
            </ion-item>
          </ion-list>
          
          <ion-radio-group *ngIf="form.type === 'radiobutton'" [(ngModel)]="form.answer">
            <ion-item *ngFor="let entry of form.answers; let j = index">
              <ion-radio (ionFocus)="radioSelected(entry.label)" [value]="entry.label" [checked]="entry.label === form.answer">
                <div style="white-space: normal;">
                  {{ entry.label | translate }}
                </div>
              </ion-radio>
            </ion-item>
          </ion-radio-group>

          <div *ngIf="i===0 || i=== 3 || i===4 || i===7" class="textDiv">
            <ion-textarea *ngIf="form.textField !== undefined" [(ngModel)]="form.textField" rows="2" spellcheck="true" autoGrow="true"></ion-textarea>
          </div>

        </div>

    </div>

    <ion-grid>
      <ion-row>
        <ion-col size="6">
          <ion-button expand="full" shape="round" color="primary" (click)="back()">
            {{'backSurvey' | translate}}
          </ion-button>
        </ion-col>
        <ion-col size="6">
          <ion-button expand="full" shape="round" color="primary" (click)="next()">
            {{ ((step===12)?'send':'nextSurvey') | translate}}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>

    <div *ngIf="step>1" class="percentageDiv">
      

      <div class="progress-outer">
        <div class="progress-inner" [style.width]="(((step-1)* 100/forms.length ).toFixed(0)) + '%'">{{((step-1)* 100/forms.length ).toFixed(0)}}%</div>
      </div>


    </div>

    </div>
  </div>

</ion-content>
